import React from "react";
import { Container, Table } from "react-bootstrap";
import PropTypes from "prop-types";
import PropertySearchResult from "./PropertySearchResult";

function PropertySearchResults({ searchResults, type }) {
  if (!searchResults || searchResults.length === 0) {
    return (
      <Container className="coreContent">
        <p>No results were found for the search.</p>
      </Container>
    );
  }

  return (
    <Container className="coreContent">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Address</th>
            <th>Site</th>
            <th>Postcode</th>
            {["WorkOrder", "WorkItem"].includes(type) && <th>Work Order</th>}
            {type === "WorkItem" && <th>Work Item</th>}
          </tr>
        </thead>
        <tbody>
          {searchResults.map((result) => (
            <PropertySearchResult
              key={result.PropertyID}
              result={result}
              type={type}
            />
          ))}
        </tbody>
      </Table>
    </Container>
  );
}

PropertySearchResults.propTypes = {
  searchResults: PropTypes.arrayOf(
    PropTypes.shape({ PropertyID: PropTypes.string })
  ).isRequired,
  type: PropTypes.string.isRequired,
};

export default PropertySearchResults;
